import React from "react";
import logo from "../../gallery/logo.png";
import { Link } from "react-router-dom";

function EventFooter() {

  function goToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  return (
    <>
      <footer className="footer-bottom">
        <div className="container">
          <div className="d-flex flex-column flex-lg-row justify-content-between ">
            <div className="d-flex align-items-center justify-content-center justify-content-lg-start mb-4 mb-lg-0">
              <Link onClick={goToTop} to="/">
                <img src={logo} alt={"Sahi Search"} className="footer-brand" />
              </Link>
            </div>
            <div className="text-end d-flex justify-content-center align-items-center flex-column mb-lg-0">
              <p className="footer-copy-right">
                Powered by <Link onClick={goToTop} to="/" className="footer-copy-right">Sahi Search</Link>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
export default EventFooter;
